export default __webpack_public_path__ + "img/b6767fdc77b41dece6a8cd2d56244c8d.svg";